import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import TeamSection from "@/components/TeamSection";
import GlobalExpansionSection from "@/components/GlobalExpansionSection";
import SEO from "@/components/SEO";

const Team = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Meet The Team | Neil AI Global Solutions"
        description="Meet the executive leadership, sales, and technology team behind Neil AI Global Solutions — now expanding into Cape Town, South Africa."
        keywords="Neil AI team, Albert Saunders, Shaun Booysen, Brannakin Jacobs, Cape Town South Africa AI, PUDU robotics dealer team"
      />
      <Navigation />
      <main className="pt-32 md:pt-40">
        <GlobalExpansionSection />
        <TeamSection />
      </main>
      <Footer />
    </div>
  );
};

export default Team;
